<template>
  <div v-if="dmpUrls.length">
    <img v-for="item in dmpUrls" :key="item.name" :src="item.url" alt="DMP tracking code" style="display: none !important" />
  </div>
</template>
<script>
import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import { categoryDMP } from '../constants/categoryDMP';
import { tagDMP } from '../constants/tagDMP';

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const dmpUrls = ref([]);
    const dmpSet = ref(new Set());
    onMounted(() => {
      const categories = props.item.categories.map((category) => category.name).filter((category) => categoryDMP[category] !== undefined);
      const tags = props.item.tags.filter((tag) => tagDMP[tag] !== undefined);

      // Category DMP Segments
      categories.forEach((category, index) => {
        const dmpList = categoryDMP[category];
        if (dmpList) {
          dmpSet.value = new Set([...dmpSet.value, ...dmpList]);
        }
      });
      dmpSet.value.forEach((dmp, index) => {
        const url = new URL(dmp);
        url.searchParams.append('timestamp', +new Date());
        dmpUrls.value.push({ name: `category_dmp_${index}`, url });
      });

      // Tag DMP Segments
      tags.forEach((tag) => {
        const dmpList = tagDMP[tag];
        dmpList.forEach((dmp, index) => {
          const url = new URL(dmp);
          url.searchParams.append('timestamp', +new Date());
          dmpUrls.value.push({ name: `tag_${tag}_${index}`, url });
        });
      });

      // Adform Article Segments
      const now = parseInt(new Date().getTime() / 1000);
      props.item.segments.forEach(function (segment) {
        const adformSegments =
          JSON.parse(window.localStorage.getItem('adform_segments_articles')) ||
          window.localStorage.setItem('adform_segments_articles', JSON.stringify({})) ||
          JSON.parse(window.localStorage.getItem('adform_segments_articles'));
        if (!adformSegments.hasOwnProperty(segment) || now > adformSegments[segment]) {
          adformSegments[segment] = now + 5184000;
          window.localStorage.setItem('adform_segments_articles', JSON.stringify(adformSegments));
          const segmentArr = segment.split('|');
          const segmentUrl =
            (segment.indexOf('http') !== 0 ? '//dmp.adform.net/dmp/profile/?pid=10548&sg=' : '') + segmentArr[segmentArr.length - 1];
          dmpUrls.value.push({ name: `segment_${segment}`, url: segmentUrl });
        }
      });
    });
    return { dmpUrls };
  },
});
</script>
